import request from '@/utils/request'


// 查询规格列表
export function listSpec(query) {
  return request({
    url: '/user/spec/list',
    method: 'get',
    params: query
  })
}

// 查询规格分页
export function pageSpec(query) {
  return request({
    url: '/user/spec/page',
    method: 'get',
    params: query
  })
}

// 查询规格详细
export function getSpec(data) {
  return request({
    url: '/user/spec/detail',
    method: 'get',
    params: data
  })
}

// 新增规格
export function addSpec(data) {
  return request({
    url: '/user/spec/add',
    method: 'post',
    data: data
  })
}

// 修改规格
export function updateSpec(data) {
  return request({
    url: '/user/spec/edit',
    method: 'post',
    data: data
  })
}

// 仅更新排序（不走 edit）
export function updateSpecSort(data) {
  return request({
    url: '/user/spec/update-sort',
    method: 'post',
    data: data
  })
}

// 仅更新状态（不走 edit）
export function updateSpecStatus(data) {
  return request({
    url: '/user/spec/update-status',
    method: 'post',
    data: data
  })
}

// 删除规格
export function delSpec(data) {
  return request({
    url: '/user/spec/delete',
    method: 'post',
    data: data
  })
}
